import { render, staticRenderFns } from "./LinkCover.vue?vue&type=template&id=5f684930&"
import script from "./LinkCover.vue?vue&type=script&lang=js&"
export * from "./LinkCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports